import { createContext } from 'react';

import type { Config } from '../types';

export const Context = createContext<Config>({
  setConfig: () => undefined,
});
